"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCEPT_LANGUAGE = void 0;
// Cannot use the one from ori/fetching due to not capital A and L in accept-language
const ACCEPT_LANGUAGE = exports.ACCEPT_LANGUAGE = 'Accept-Language';
//# sourceMappingURL=types.js.map